import { cn } from '@/utils/cn';

interface UserDataProps extends React.HTMLAttributes<HTMLDivElement> {
  open: boolean;
  name: string;
  companyName: string | undefined;
  initials: string | undefined;
}

export const UserData: React.FC<UserDataProps> = ({ open, name, companyName, initials, ...props }) => {
  return (
    <div
      role="button"
      {...props}
      className={cn(
        'group flex h-14 min-w-48 cursor-pointer items-center justify-end gap-3 border-l border-none pr-4 pl-4 transition-all duration-200 focus-visible:outline-none',
        open ? 'bg-secondary-300' : 'hover:bg-secondary-300'
      )}
    >
      <div className="flex flex-col text-right">
        <span
          className={cn(
            'font-semibold transition-all duration-200',
            open ? 'text-typography-300' : 'text-primary group-hover:text-typography-300'
          )}
        >
          {companyName}
        </span>

        <span
          className={cn(
            'text-xs font-normal transition-all duration-200',
            open ? 'text-typography' : 'text-typography-100 group-hover:text-typography'
          )}
        >
          {name}
        </span>
      </div>

      <div
        className={cn(
          'flex h-10 w-10 items-center justify-center rounded-full transition-colors duration-200',
          open ? 'bg-primary-100 text-typography' : 'bg-primary text-typography group-hover:bg-primary-100'
        )}
      >
        <span className="inline-block -translate-x-[0.5px]">{initials}</span>
      </div>
    </div>
  );
};
